import React from 'react';

const Footer = () => {
   return (
      <div className=' bg-primary  text-2xl font-semibold capitalize mt-20 text-center  text-secondary px-5 py-10'>
         <p className="">&copy;All rights reserved by Mostafizur Rahaman </p>
      </div>
   );
};

export default Footer;